import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import PageHeaderSection from '../../components/layout/PageHeaderSection';
import Button from '../../components/common/Button';
import { useChessCoach } from '../../context/ChessCoachContext';

/**
 * Deep-link entry — opens the floating coach widget (available on every page).
 */
export default function AiCoachPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const { openCoach } = useChessCoach();
  const gameIdRaw = params.get('gameId');
  const gameId = gameIdRaw && /^\d+$/.test(gameIdRaw) ? Number(gameIdRaw) : null;
  const plyRaw = params.get('ply');
  const focusPly = plyRaw && /^\d+$/.test(plyRaw) ? Number(plyRaw) : null;

  useEffect(() => {
    openCoach({ gameId, focusPly });
  }, [focusPly, gameId, openCoach]);

  return (
    <div className="page-shell-form playing-page max-w-2xl">
      <PageHeaderSection
        eyebrow={t('nav.playingPlatform')}
        title={t('playing.coach.pageTitle', { defaultValue: 'Ask AI Coach' })}
        subtitle={t('playing.coach.widgetPageSubtitle', {
          defaultValue: 'The coach chat opens in the bottom-right corner — use it from any page while you browse ChessDesk.',
        })}
      />
      <div className="playing-panel-card space-y-4 p-6 text-center">
        <p className="text-sm text-slate-600">
          {t('playing.coach.widgetPageHint', {
            defaultValue: 'Look for the Ask AI Coach button at the bottom-right of your screen. Minimize it anytime and reopen from there.',
          })}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button type="button" variant="page-primary" onClick={() => openCoach({ gameId, focusPly })}>
            {t('playing.coach.openChat', { defaultValue: 'Open Ask AI Coach' })}
          </Button>
          <Link to="/playing" className="btn-page-action-secondary px-4 py-2 text-sm">
            {t('playing.backToHub', { defaultValue: 'Back to Play Hub' })}
          </Link>
        </div>
      </div>
    </div>
  );
}
